/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileCodeLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FileCodeLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M29.406 28.474 20.944 37.5l8.462 9.026 2.188-2.052-6.538-6.974 6.538-6.974-2.188-2.052Zm16.688 0-2.188 2.052 6.538 6.974-6.538 6.974 2.188 2.052 8.462-9.026-8.462-9.026Zm-7.054-4.311-6.003 26 2.923.674 6.002-25.999-2.923-.675Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m33.038 50.162 6.002-25.999 2.923.675-.22.95-2.703-.625-5.783 25.05-.22-.05Zm-3.632-21.688L20.944 37.5l.47.5 7.992-8.526 1.69 1.584.498-.532-2.188-2.052Zm1.69 16.468.498-.468L25.525 38l-.469.5 6.04 6.442Zm14.998-16.468-2.188 2.052.5.532 1.688-1.584L54.087 38l.47-.5-8.463-9.026Zm-1.689 16.468 6.04-6.442-.47-.5-6.069 6.474.5.468Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FileCodeLarge
};
